<template>
  <div
    :class="[
      'protocol-container',
      isMobile ? 'mobile' : '',
      isMinip ? 'minip' : '',
    ]"
  >
    <div class="protocol">
      <p class="title" id="div1">豹火隐私政策</p>
      <div class="container">
        <div class="update-data">
          <p class="time compact">更新时间：2025年03月19日</p>
          <p class="time compact">生效时间：2025年03月19日</p>
        </div>
        <p>
          豹火官方网站、豹火App和“豹火”小程序由问问智能信息科技有限公司(注册地为北京市海淀区高梁桥斜街42号院1号楼4层2-406)开发。问问智能信息科技有限公司(注册地为北京市海淀区高梁桥斜街42号院1号楼7层1-728)开发（以下统称<span
            class="highlight"
            >“问问智能”</span
          >或<span class="highlight">“我们”</span
          >）通过豹火官方网站、豹火App和“豹火”小程序提供产品及服务(以下统称<span
            class="highlight"
            >“豹火产品及服务”</span
          >)。
        </p>
        <p>
          我们尊重并保护用户的隐私和数据。在您使用豹火产品及服务时，我们会收集、使用、存储和共享您的个人信息和其他不具有识别性的相关数据。我们深知个人信息对您的重要性，并会尽全力保护您的个人信息安全、可靠。
        </p>
        <p>
          我们希望通过本《豹火隐私政策》（以下简称<span class="highlight"
            >“本政策”</span
          >）向您说明您在使用豹火产品及服务时我们如何收集、使用、存储和共享这些数据，以及我们为您提供的访问、更正、删除和保护个人信息的方式。我们在此提示您：
        </p>
        <p>
          1.
          <span class="highlight">
            本政策仅适用于豹火产品及服务，不适用于第三方通过豹火产品及服务向您提供的产品或服务，当您通过豹火产品及服务链接到其它网站、客户端或移动应用时，我们无法控制该等第三方收集或获取您的信息。</span
          >
        </p>
        <p>
          2.
          <span class="highlight">
            豹火产品及服务仅面向18周岁以上的成年人。我们要求注册用户是具备完全民事行为能力的自然人，未成年人不得注册自己的用户帐号。我们进一步声明，豹火产品及服务不面向任何14周岁以下的儿童。</span
          >
        </p>
        <p>
          3.
          本政策与您使用的豹火产品及服务息息相关。对于本政策中与您的权益可能存在重大关系的条款，我们已采用<span
            class="highlight"
            >粗体</span
          >标识进行标注。在使用豹火产品及服务前，请您务必审慎阅读并确认您已经充分理解本政策所写明的内容。请特别注意以<span
            class="highlight"
            >粗体</span
          >标识的条款，但也请注意本政策全文内容的重要性。<span class="highlight"
            >您应在充分理解、确认并同意本政策的全部内容后再开始使用豹火产品及服务，以便您可以按照本政策的指引做出您认为适当的选择。</span
          >
        </p>
        <p class="title">本政策帮助您了解以下内容：</p>
        <p class="title">一. 我们如何收集和使用您的个人信息</p>
        <p class="title">二. 我们如何存储您的个人信息</p>
        <p class="title">三. 我们如何使用Cookies及相关技术</p>
        <p class="title">四. 我们如何共享、转让和公开披露您的个人信息</p>
        <p class="title">五. 我们如何保护您的个人信息</p>
        <p class="title">六. 您如何管理您的个人信息</p>
        <p class="title">七. 本政策的修订和更新</p>
        <p class="title">八. 如何联系我们</p>
        <p class="title">九. 相关术语</p>
        <p class="title">一. 我们如何收集和使用您的个人信息</p>
        <p>
          在您使用豹火产品及服务过程中，为了实现产品及服务之功能，我们根据合法、正当、必要原则仅收集下列与您有关的信息。
        </p>
        <p class="title">(一) 豹火小程序</p>
        <p class="compact flex">
          <span class="serial">1.</span>
          <span
            >1.为帮助您成功注册、登录豹火账户，并进一步向您提供豹火产品及服务，您需要向我们提供您的手机号码和短信验证码。</span
          >
        </p>
        <p class="compact flex">
          <span>2.</span>
          <span
            >2.当您使用微信账户登录豹火小程序时，您同意我们收集您的微信用户唯一标识（Openid），以便您能够通过微信账户快捷登录。经您授权同意，我们还会收集您微信账户绑定的手机号码，以作为您的身份标识。</span
          >
        </p>
        <p class="compact flex">
          <span>3.</span>
          <span
            >当您使用豹火产品及服务的配音功能时，为了合成相关音频，同时方便您自行管理您的作品，查询、编辑、删除相关文章，我们将保存您主动上传的文本内容。</span
          >
        </p>
        <p class="compact flex">
          <span>4.</span>
          <span
            >为了方便您试听、修改配音作品，我们将保存您使用豹火产品及服务制作的音频作品。</span
          >
        </p>
        <p class="compact flex">
          <span>5.</span>
          <span
            >当您使用豹火产品及服务的效率工具时，您可能需要上传相应的视频链接、视频文件、音频文件或文案文件后进行相应操作。但为您的隐私安全考虑，我们建议您不要上传任何可能包含个人信息或私密信息的文件。</span
          >
        </p>
        <p class="compact flex">
          <span>6.</span>
          <span
            >当您购买豹火会员服务或声音商店的声音商品时，为统计销售情况、向您提供售后支持，我们将收集您的<span
              class="highlight"
              >订单编号、下单时间和付款金额</span
            >。</span
          >
        </p>
        <p class="compact flex">
          <span>7.</span>
          <span
            >为了优化产品使用体验，了解您如何接入和使用豹火产品及服务，我们将收集您的<span
              class="highlight"
              >使用记录数据（如点击数据）、搜索记录</span
            >。为了优化产品使用体验，我们和我们的合作伙伴可能会将该等数据用于图表分析，以及通知您有关更新或升级的服务和功能的信息、提供客户支持、通知您最新的运营活动信息、促销信息等。但该等数据不包含任何您的个人信息。</span
          >
        </p>
        <p class="compact flex">
          <span>8.</span>
          <span
            >当您通过豹火App或豹火小程序加入豹火会员交流群、联系官方客服时，为保存相关二维码，我们会请求您授权相应功能所需的<span
              class="highlight"
              >访问设备上的照片、媒体内容和相册的权限</span
            >。若您不同意或取消授权，将无法使用相应功能如保存二维码至相册，但不影响您使用豹火App或豹火小程序的其他功能。</span
          >
        </p>
        <p class="compact flex">
          <span>9.</span>
          <span
            >当您使用豹火产品的声音克隆功能时，为了生成您的专属声音，我们将收集并使用<span
              class="highlight"
              >您主动上传的语音数据</span
            >。您也可以通过联系我们的工作人员提交您的语音数据。</span
          >
        </p>
        <p class="compact flex">
          <span>10.</span
          ><span
            >当您使用豹火小程序的分享赚钱功能时，您需要将豹火小程序或海报“分享给群/好友”或“分享朋友圈”，对于因您的分享而带来的豹火新用户，当他首次开通豹火会员时，您将获得分销等级所对应的销售分成。为证明您满足分享赚钱活动的条件，我们将收集您的<span
              class="highlight"
              >分享次数、分享来源以及您的分享引入的其他用户信息</span
            >。</span
          >
        </p>
        <p class="compact flex">
          <span>11.</span
          ><span
            >当您使用豹火产品文案提取、去水印功能时，我们会请求您授权相应功能所需的<span
              class="highlight"
              >剪贴板权限</span
            >。若您不同意或取消授权，将无法使用相应功能如文案提取、去水印等，但不影响您使用豹火产品的其他功能。</span
          >
        </p>
        <p class="compact flex">
          <span>12.</span
          ><span
            >在豹火App运行期间，我们需要收集您的设备品牌、设备型号、操作系统版本、IP地址、粘贴板（剪切板），用于数据统计和分析；收集您的设备序列号（SerialNumber）、Android_ID、本地存储权限、手机外置存储信息，用于数据统计作弊监控；收集您的MAC地址、IMEI、IDFA、DEVICE_ID、OAID、SIM卡信息，用于移动广告效果监测、提供统计分析及其他服务；收集您的应用启动数据及异常错误日志，用于分析改进性能和用户体验，为您提供更好的服务；获取自启动权限，为第三方SDK（蒲公英应用分发平台）提醒您完成定时事项，若拒绝此权限您的定时提醒可能不会按时提醒。</span
          >
        </p>
        <p class="compact flex">
          <span>13.</span
          ><span
            >为实现豹火产品与关联产品和/或服务的账户互通，我们会与关联产品一同使用您的账号/权益类信息（如手机号、用户账号），且受本政策所声明目的的约束。关联产品如要改变个人信息的处理目的，将再次征求您的授权同意。</span
          >
        </p>
        <p class="compact flex">
          <span>14.</span
          ><span
            >当您使用豹火提现功能时，为了您能使用提现服务，在将您的银行卡与豹火账户绑定时，您需提供您的<span
              class="highlight"
              >银行卡卡号、姓名、身份证号码、银行预留手机号</span
            >。如您不提供上述信息，将无法使用快捷支付服务。</span
          >
        </p>
        <p class="title">
          （二) 无需征得您的授权同意而收集和使用您的个人信息的情形
        </p>
        <p class="highlight compact">
          您充分理解并同意，我们在法律允许的范围内，在以下任一情况下收集、使用您的个人信息无需征得您的授权同意：
        </p>
        <p class="highlight compact flex">
          <span>1. </span><span>与我们履行适用法律法规规定的义务相关的；</span>
        </p>
        <p class="highlight compact flex">
          <span>2. </span><span>与国家安全、国防安全直接相关的；</span>
        </p>
        <p class="highlight compact flex">
          <span>3. </span
          ><span>与公共安全、公共卫生、重大公共利益直接相关的；</span>
        </p>
        <p class="highlight compact flex">
          <span>4. </span
          ><span>与刑事侦查、起诉、审判和判决执行等直接相关的；</span>
        </p>
        <p class="highlight compact flex">
          <span> 5. </span
          ><span
            >出于维护您或其他个人的生命健康、财产安全等重大合法权益但又难以得到本人授权同意的；</span
          >
        </p>
        <p class="highlight compact flex">
          <span>6. </span
          ><span>所涉及的个人信息是您自行向社会公众公开的；</span>
        </p>
        <p class="highlight compact flex">
          <span>7. </span><span>根据您的要求签订和履行合同所必需的；</span>
        </p>
        <p class="highlight compact flex">
          <span>8.</span>
          <span
            >从合法公开披露的信息中收集的个人信息，如合法的新闻报道、政府信息公开等渠道；</span
          >
        </p>
        <p class="highlight compact flex">
          <span> 9.</span>
          <span
            >为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息；</span
          >
        </p>
        <p class="highlight compact flex">
          <span>10.</span>
          <span
            >维护所提供的产品和服务的安全稳定运行所必需的，例如发现、处置内容和服务故障。</span
          >
        </p>
        <p class="title">二、 我们如何存储您的个人信息</p>
        <p class="compact flex">
          <span>1.</span>
          <span
            >原则上，我们在中华人民共和国境内收集和产生的个人信息，将存储在中华人民共和国境内。我们会以法律允许的方式确保个人信息的存储安全。</span
          >
        </p>
        <p class="compact flex">
          <span>2.</span>
          <span
            >我们只会在达成本政策载明目的所及法律法规要求的最短保存期限内，保留您的个人信息。前述期限届满后，我们会对您的个人信息进行删除或者匿名化处理。此外，如果我们终止提供服务，我们会在终止提供服务后对您的个人信息进行删除或匿名化处理，但法律法规、相关国家标准另有要求或为履行我们的合规义务而保留您的个人信息的情形除外。</span
          >
        </p>
        <p class="compact flex">
          <span>3.</span>
          <span class="highlight"
            >当您成功申请注销帐号后，我们将对您的个人信息进行删除或匿名化处理。</span
          >
        </p>
        <p class="title">三、 我们如何使用Cookies及相关技术</p>
        <p class="compact flex">
          <span>1.</span
          ><span>
            我们和第三方合作伙伴会在您的计算机或移动设备上使用Cookies、日志文件（log
            files）、网络信标（web
            beacons）、编程脚本（scripts）、标签（tags）及其他追踪技术（以上合称“<span
              class="highlight"
              >“Cookies及相关技术”</span
            >）。我们和我们的第三方合作伙伴可能通过Cookies收集您的信息，以记住您的身份，并分析您如何使用我们的服务。</span
          >
        </p>
        <p class="compact flex">
          <span>2.</span>
          <span class="highlight">
            第三方合作伙伴通过Cookies收集和使用您的信息不受本政策约束，而是受到其自身的信息保护声明约束，我们不对第三方的Cookies或同类技术承担责任。</span
          >
        </p>
        <p class="compact flex">
          <span>3.</span
          ><span>
            如果您的浏览器或浏览器附加服务允许，您可修改对Cookies的接受程度或拒绝我们的Cookies。但如果您这么做，我们可能会无法向您提供最佳的豹火产品及服务的使用体验，部分功能亦可能会无法正常运作。</span
          >
        </p>
        <p class="title">四、 我们如何共享、转让和公开披露您的个人信息</p>
        <p class="title">(一) 共享</p>
        <p>我们仅会在以下情形下共享您的个人信息：</p>
        <p class="compact flex">
          <span>1.</span><span>事先获得您的明确授权或同意；</span>
        </p>
        <p class="compact flex">
          <span>2. </span
          ><span
            >履行法定义务所必需：根据适用的法律法规、诉讼、争议解决的必要，或按行政、司法机关依法提出的要求，以及其他法定义务履行所必需而共享您的个人信息；</span
          >
        </p>
        <p class="compact flex">
          <span>3. </span
          ><span
            >在法律要求或允许的范围内，为了保护问问智能及其用户或社会公众的利益、财产或安全免遭损害而有必要提供；</span
          >
        </p>
        <p class="compact flex">
          <span>4. </span
          ><span
            >豹火产品及服务的部分功能由我们的关联公司提供。为了实现该等功能，我们可能在最小必要范围内向我们的关联公司共享您的个人信息；</span
          >
        </p>
        <p class="compact flex">
          <span>5. </span
          ><span
            >与合作伙伴共享：仅为实现本政策中声明的目的，我们的某些服务将由合作伙伴提供。我们可能会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。我们的合作伙伴无权将共享的个人信息用于任何其他用途。具体请点击<a
              href="#/commonList"
              target="_blank"
              >《豹火信息共享清单》</a
            >。</span
          >
        </p>
        <p class="compact flex">
          <span>6. </span
          ><span class="highlight"
            >为确保部分独立功能的实现，我们的部分服务及功能由第三方SDK提供。我们将审慎评估该等SDK的使用目的。了解更多有关SDK处理个人信息的目的、方式及范围等信息，请点击<a
              href="#/sdkList"
              target="_blank"
              >《第三方SDK收集个人信息列表》</a
            >。</span
          >
        </p>
        <p class="title">(二) 转让</p>
        <p class="compact">
          我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：
        </p>
        <p class="compact flex">
          <span>1.</span> <span>我们已事先获得您明确的同意或授权；</span>
        </p>
        <p class="compact flex">
          <span>2.</span>
          <span
            >根据适用的法律法规、法律程序的要求，强制性的行政或司法要求所必需的情况进行提供；</span
          >
        </p>
        <p class="compact flex">
          <span>3.</span>
          <span class="highlight"
            >在涉及合并、收购、资产转让、破产或类似的交易时，您的个人信息有可能作为此类交易的一部分而被转让。如涉及个人信息转让，我们将通过通知、公告等形式告知您相关情形，并会按照法律法规及不低于本政策所要求的标准继续保护或要求新的持有您个人信息的受让方继续受本政策的约束，否则，我们将要求该受让方重新向您征求授权同意。如破产且无承接方的，您的个人信息将做删除处理。</span
          >
        </p>
        <p class="title">(三) 公开披露</p>
        <p>
          您的个人信息原则上不会被我们公开披露。我们仅会在符合以下要求的情况下，经法律法规授权或具备合理事由确需公开披露时，公开披露您的个人信息：
        </p>
        <p class="highlight compact flex">
          <span>1.</span
          ><span
            >事先开展个人信息安全影响评估，并依评估结果采取有效的保护措施；</span
          >
        </p>
        <p class="highlight compact flex">
          <span>2.</span>
          <span
            >向您告知公开披露个人信息的目的、类型及所涉敏感信息的内容，并事先征得您的明示同意。</span
          >
        </p>
        <p class="title">
          (四) 共享、转让、公开披露个人信息时事先征得同意的例外
        </p>
        <p class="highlight compact flex">
          请注意，以下情形中，我们共享、转让、公开披露您的个人信息不必事先征得您的授权同意：
        </p>
        <p class="highlight compact flex">
          1. 与我们履行法律法规规定的义务相关的；
        </p>
        <p class="highlight compact flex">
          2. 与国家安全、国防安全直接相关的；
        </p>
        <p class="highlight compact flex">
          3. 与公共安全、公共卫生、重大公共利益直接相关的；
        </p>
        <p class="highlight compact flex">
          4. 与刑事侦查、起诉、审判和判决执行等直接相关的；
        </p>
        <p class="highlight compact flex">
          5.
          出于维护您或其他个人的生命、财产等重大合法权益但又难以得到本人授权同意的；
        </p>
        <p class="highlight compact flex">
          6. 您自行向社会公众公开的您的个人信息；
        </p>
        <p class="highlight compact flex">
          7.
          从合法公开披露的信息中收集您的个人信息的，如合法的新闻报道、政府信息公开等渠道。
        </p>
        <p class="title">五、 我们如何保护您的个人信息</p>
        <p class="compact flex">
          <span>1.</span>
          <span
            >我们会采取一切合理可行的措施，保护您的个人信息，防止数据遭到未经授权的访问、公开披露、使用、修改、损坏或丢失。例如，在您的浏览器与“服务”之间交换数据时受SSL加密保护；我们同时对本政策适用的网站提供https安全浏览方式；我们会使用加密技术确保数据的保密性；我们会使用受信赖的保护机制防止数据遭到恶意攻击。</span
          >
        </p>
        <p class="compact flex">
          <span>2.</span>
          <span
            >我们会建立专门的管理制度，部署访问控制机制，确保只有授权人员才可访问个人信息；此外，我们还会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。</span
          >
        </p>
        <p class="compact flex">
          <span>3.</span>
          <span
            >我们严格遵守《中华人民共和国网络安全法》、《中华人民共和国个人信息保护法》及其他适用法律法规的要求并主动遵循《信息安全技术
            个人信息安全规范》（GB/T 35273—2020）的指引。</span
          >
        </p>
        <p class="compact flex">
          <span>4.</span>
          <span
            >互联网并非绝对安全的环境，但我们将尽力确保您发送给我们的任何信息的安全性。在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、弹窗通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。</span
          >
        </p>
        <p class="title">六、 您如何管理您的个人信息</p>
        <p class="title">（一）访问您的个人信息</p>
        <p>
          您有权随时访问您的个人信息。但出于账户安全考虑，我们可能会限制您每天接收登录验证码的次数。
        </p>
        <p>当您使用豹火网站时：</p>
        <p class="compact flex">
          <span>1.</span>
          <span
            >您可以通过“头像→消费记录”访问您购买会员、合成音频的消费记录；</span
          >
        </p>
        <p class="compact flex">
          <span>2.</span>
          <span
            >您可以通过“软件配音→内容管理→我的文章”或“头像→我的作品”访问您的作品；</span
          >
        </p>
        <p class="flex">
          <span>3.</span>
          <span
            >如果您无法通过上述方式访问您在豹火网站中的个人信息，您可以发送电子邮件至voicemaker-service@mobvoi.com提出访问申请，我们将在15日内响应您的访问请求。</span
          >
        </p>
        <p>当您使用豹火App时：</p>
        <p class="compact flex">
          <span>1.</span>
          <span
            >您可以通过“我的”界面访问您的用户名、头像以及您注册登录的手机号；</span
          >
        </p>
        <p class="compact flex">
          <span>2.</span>
          <span>您可以通过“我的→作品管理→配音作品”访问您的作品；</span>
        </p>
        <p class="flex">
          <span>3.</span>
          <span
            >如果您无法通过上述方式访问您在豹火App中的个人信息，您可以发送电子邮件至voicemaker-service@mobvoi.com提出访问申请，我们将在15日内响应您的访问请求。</span
          >
        </p>
        <p>当您使用豹火小程序时：</p>
        <p class="compact flex">
          <span>1.</span>
          <span
            >您可以通过“我的”界面访问您登录账户的用户账号、头像、昵称以及您注册登录的手机号；</span
          >
        </p>
        <p class="compact flex">
          <span>2.</span>
          <span>您可以通过“我的→作品管理→配音作品/歌唱作品”访问您的作品；</span>
        </p>
        <p class="compact flex">
          <span>3.</span>
          <span>您可以通过“我的→我的钱包”查看您的分销提现金额及分销明细；</span>
        </p>
        <p class="compact flex">
          <span>4.</span>
          <span
            >如果您无法通过上述方式访问您在豹火小程序中的个人信息，您可以发送电子邮件至voicemaker-service@mobvoi.com提出访问申请，我们将在15日内响应您的访问请求。</span
          >
        </p>
        <p class="title">（二）更正您的个人信息</p>
        <p>您有权随时更正您的个人信息。</p>
        <p>当您使用豹火网站时：</p>
        <p class="compact flex">
          <span>1.</span>
          <span
            >您可以通过“软件配音→内容管理→我的文章”或“头像→我的作品”修改您的作品；</span
          >
        </p>
        <p class="flex">
          <span>2.</span>
          <span
            >您可以通过联系人工客服{{
              telPhone
            }}或发送电子邮件至voicemaker-sevice@mobvoi.com，向我们申请更正其他个人信息，我们将在15日内响应您的更正请求。</span
          >
        </p>
        <p>当您使用豹火小程序时：</p>
        <p class="compact flex">
          <span>1.</span>
          <span
            >您通过微信账户快捷登录豹火小程序时，您可以通过更改微信头像、昵称以更改豹火小程序头像、昵称；</span
          >
        </p>
        <p class="compact flex">
          <span>2.</span>
          <span>您可以通过“我的→作品管理→配音作品/歌唱作品”修改您的作品；</span>
        </p>
        <p class="compact flex">
          <span>3.</span>
          <span
            >您可以通过联系人工客服{{
              telPhone
            }}或发送电子邮件至voicemaker-service@mobvoi.com，向我们申请更正其他个人信息，我们将在15日内响应您的更正请求。</span
          >
        </p>
        <p class="title">（三） 删除您的个人信息</p>
        <p>您有权随时删除您的个人信息。</p>
        <p>当您使用豹火网站时：</p>
        <p class="compact flex">
          <span>1.</span>
          <span
            >您可以通过“软件配音→内容管理→我的文章”或“头像→我的作品”删除您的作品；</span
          >
        </p>
        <p class="compact flex">
          <span>2. </span
          ><span
            >您可以通过联系人工客服{{
              telPhone
            }}或发送电子邮件至voicemaker-service@mobvoi.com，向我们申请删除您的个人信息，我们将在15日内对您的请求进行处理。</span
          >
        </p>
        <p>当您使用豹火App时：</p>
        <p class="compact flex">
          <span>1.</span>
          <span>您可以通过“我的→作品管理→配音作品”删除您的作品；</span>
        </p>
        <p class="compact flex">
          <span>2.</span>
          <span
            >您可以通过联系人工客服{{
              telPhone
            }}或发送电子邮件至voicemaker-service@mobvoi.com，向我们申请删除您的个人信息，我们将在15日内对您的请求进行处理。</span
          >
        </p>
        <p>当您使用豹火小程序时：</p>
        <p class="compact flex">
          <span>1.</span>
          <span>您可以通过“我的→作品管理→配音作品/歌唱作品”删除您的作品；</span>
        </p>
        <p class="compact flex">
          <span>2.</span>
          <span
            >您可以通过联系人工客服{{
              telPhone
            }}或发送电子邮件至voicemaker-service@mobvoi.com，向我们申请删除您的个人信息，我们将在15日内对您的请求进行处理。</span
          >
        </p>
        <p>
          当您删除个人信息后，因为法律法规和安全技术的要求，我们可能不会立即从系统中删除相应的备份信息，我们将安全地存储您的个人信息并不会对其进一步使用，直到备份更新时删除这些信息或实现匿名化。
        </p>
        <p class="title">（四） 改变您授权同意的范围</p>
        <p class="compact flex">
          <span>1.</span>
          <span
            >请您理解，每个业务功能需要一些基本个人信息才能得以完成。对于最小集之外的个人信息的收集和使用，您可以随时给予或撤回您的授权同意。</span
          >
        </p>
        <p class="compact flex">
          <span>2.</span>
          <span
            >对于豹火产品及服务的撤回授权，您可以发送电子邮件至voicemaker-service@mobvoi.com提出撤回授权申请，我们将在15日内对您的请求进行处理。</span
          >
        </p>
        <p class="compact flex">
          <span>3.</span>
          <span
            >您也可以通过注销帐号的方式，撤回我们继续收集您个人信息的全部授权。</span
          >
        </p>
        <p class="compact flex">
          <span>4.</span>
          <span
            >当您撤回授权或同意后，我们将不再处理相应的个人信息。但您撤回授权或同意的决定，不会影响此前基于您的授权而开展的个人信息处理活动。</span
          >
        </p>
        <p class="title">（五） 个人信息主体帐号注销</p>
        <p class="compact flex">
          <span>1.</span>
          <span
            >您可以随时注销您的帐号，您可以通过联系人工客服{{
              telPhone
            }}或发送电子邮件至voicemaker-service@mobvoi.com，向我们申请注销帐号，我们将在15日内对您的请求进行处理。</span
          >
        </p>
        <p class="compact flex">
          <span>2.</span>
          <span
            >在注销帐号之后，我们将停止为您提供豹火产品及服务，并依据您的要求，删除或匿名化处理您的个人信息，但法律法规规定的保存期限未届满，或者删除个人信息从技术上难以实现的，我们将停止除存储和采取必要的安全保护措施之外的处理。</span
          >
        </p>
        <p class="title">（六） 获取个人信息副本</p>
        <p class="compact flex">
          <span>1. </span
          ><span
            >您有权获得您的个人信息副本，您可以通过联系人工客服{{
              telPhone
            }}或发送电子邮件至voicemaker-service@mobvoi.com，向我们申请获取个人信息副本，我们将在15日内对您的请求进行处理。</span
          >
        </p>
        <p class="compact flex">
          <span>2.</span>
          <span
            >在技术可行的前提下，例如数据接口匹配，我们还将按您的要求，直接将您的个人信息副本传输给您指定的第三方。</span
          >
        </p>
        <p class="title">（七）响应您的上述请求</p>
        <p class="compact flex">
          <span>1.</span>
          <span
            >如果您认为我们存在任何违反法律法规或本政策规定的情形，您均可以通过本政策第八条列明的联系方式与我们联系。</span
          >
        </p>
        <p class="compact flex">
          <span>2.</span>
          <span
            >为保障您的信息安全，我们可能需要您提供书面请求，或以其他方式证明您的身份。我们将在收到您反馈并验证您的身份后15日内答复您的请求。</span
          >
        </p>
        <p class="compact flex">
          <span>3.</span>
          <span
            >对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。</span
          >
        </p>
        <p class="compact highlight flex">
          <span>4.</span>
          <span>在以下情形中，按照法律法规要求，我们将无法响应您的请求：</span>
        </p>
        <p class="compact highlight flex">
          (1）与我们履行法律法规规定的义务相关的；
        </p>
        <p class="compact highlight flex">
          (2）与国家安全、国防安全直接相关的；
        </p>
        <p class="compact highlight flex">
          (3）与公共安全、公共卫生、重大公共利益直接相关的；
        </p>
        <p class="compact highlight flex">
          (4）与刑事侦查、起诉、审判和执行判决等直接相关的；
        </p>
        <p class="compact highlight flex">
          (5）我们有充分证据表明您存在主观恶意或滥用权利的；
        </p>
        <p class="compact highlight flex">
          (6）出于维护您或其他个人的生命、财产等重大合法权益但又很难得到您授权同意的；
        </p>
        <p class="compact highlight flex">
          (7）响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；
        </p>
        <p class="compact highlight flex">(8）涉及商业秘密的。</p>
        <p class="title">七、 本政策的修订和更新</p>
        <p class="compact flex">
          <span>1.</span>
          <span
            >我们可能不时修订本政策，该等修订构成本政策的一部分。未经您明确同意，我们不会实质性削减您按照本政策所应有的权利。</span
          >
        </p>
        <p class="compact flex">
          <span>2.</span>
          <span>我们会在豹火产品的显著位置发布对本政策所做的任何变更。</span>
        </p>
        <p class="title">八、 如何联系我们</p>
        <p class="compact flex">
          <span>1.</span>
          <span
            >如您对本政策有任何疑问、意见或建议或希望与我们讨论本政策或任何有关隐私事宜，请通过voicemaker-service@mobvoi.com与我们联络，我们设立了个人信息保护专职部门。一般情况下，我们将在15天内予以回复。</span
          >
        </p>
        <p class="compact flex">
          <span>2.</span>
          <span
            >如果您认为我们的个人信息处理行为损害了您的合法权益，您也可以向网信部门、工信部门、公安及市场监管等监管部门进行投诉或举报。</span
          >
        </p>
        <p class="title">九、 相关术语</p>
        <p class="compact flex">
          <span>1.</span>
          <span
            ><span class="highlight">“个人信息”</span
            >：系指以电子或者其他方式记录的与已识别或者可识别的自然人有关的各种信息，不包括匿名化处理后的信息。</span
          >
        </p>
        <p class="compact flex">
          <span>2.</span>
          <span
            ><span class="highlight">“相关数据”</span
            >：系指通过豹火产品及服务收集的除个人信息以外的数据。</span
          >
        </p>
        <p class="compact flex">
          <span>3.</span>
          <span
            ><span class="highlight">“关联方”</span
            >：系指问问智能信息科技有限公司在中国地区的关联公司，包括但不限于出门问问创新科技有限公司、北京小问智能科技有限公司，上海羽扇智信息科技有限公司、北京羽扇智信息科技有限公司、问问智能信息科技有限公司、武汉问问智能信息科技有限公司、深圳问问智能信息科技有限公司、出门问问信息科技有限公司、出门问问（武汉）信息科技有限公司、出门问问（苏州）信息科技有限公司、深圳小问智能科技有限公司、南京小问智能科技有限公司。</span
          >
        </p>
        <p class="compact flex">
          <span>4.</span>
          <span
            ><span class="highlight">“关联产品和/或服务”</span
            >：系指魔音，元创岛、元创邦、魔撰、奇妙元及其他已上线或即将上线的产品和/或服务。</span
          >
        </p>
        <p class="compact flex">
          <span>5.</span>
          <span
            ><span class="highlight">“合作伙伴”</span
            >：系指帮助问问智能提供豹火产品及服务的第三方服务提供商。</span
          >
        </p>
        <p class="compact flex">
          <span>6.</span>
          <span
            ><span class="highlight">“去标识化”</span
            >：系指个人信息经过处理，使其在不借助额外信息的情况下无法识别特定自然人的过程。</span
          >
        </p>
        <p class="compact flex">
          <span>7. </span
          ><span
            ><span class="highlight">“匿名化”</span
            >：系指个人信息经过处理无法识别特定自然人且不能复原的过程。</span
          >
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isMobile: false,
      isMinip: false,
	  telPhone:'130 5119 2686'
    };
  },
  methods: {
	checkIsMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return !!flag;
    },
  },
  mounted() {
    this.isMobile = checkIsMobile();
    let ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf("micromessenger") != -1 || ua.indexOf("miniProgram") != -1) {
      //ios的ua中无miniProgram，但都有MicroMessenger（表示是微信浏览器）
      this.isMinip = true;
    }
    if (this.isMobile) {
      document.title = "豹火";
    }
  },
};
</script>

<style lang="less" scoped>
.protocol-container {
  font-size: 16px;
  width: 100%;
  overflow: auto;
  height: 100vh;
  background: #fff;
  color: #1f2329 !important;

  .highlight {
    font-weight: 800;
  }

  .protocol {
    min-width: 470px;
    max-width: 790px;
    border-radius: 4px;
    box-sizing: border-box;
    padding: 20px;
    margin: 20px auto;
    background: #fff;
    box-shadow: 0px 0px 11px 0px rgba(63, 95, 150, 0.04);

    .title {
      width: 100%;
      margin: 36px 0 22px;
      text-align: center;
      font-size: 34px;
      font-weight: 500;
      color: #1f2329;
    }

    .update-data {
      padding: 12px 0;
      text-align: center;

      .time {
        font-size: 16px;
        font-weight: 800;
        text-align: left;
      }
    }

    .container {
      margin-top: 20px;

      .title {
        font-size: 16px;
        margin-top: 32px;
        font-weight: 800;
        text-align: left;
      }

      .time {
        text-align: left;
      }

      p {
        margin-bottom: 20px;

        .highlight {
          font-weight: 800;
        }

        a {
          color: #5a92f4;
        }

        &.compact {
          margin-bottom: 0px;
        }

        &.flex {
          display: flex;

          > span:nth-child(2) {
            margin-left: 1em;
          }
        }

        .q {
          margin-left: 1em;
        }
      }

      .update-data {
        .time {
          font-weight: 800;
        }

        p {
          font-weight: 800;
        }
      }
    }
  }
}

@media screen and (max-width: 1920px) {
  .protocol {
    width: 80%;
  }
}

// @media screen  and (max-width: 1400px){
//   .protocol{
//     width:80%
//   }
// }
@media screen and (max-width: 1279px) {
  .protocol {
    width: 70%;
  }
}

@media screen and (max-width: 900px) {
  .protocol {
    width: calc(100% - 40px);
  }
}

.protocol-container {
  &.mobile:not(.minip) {
    .protocol {
      min-width: auto;
      max-width: none;
      border-radius: 4rpx;
      height: auto;
      box-sizing: border-box;
      padding: 0;
      margin: 20rpx auto !important;
      background: #fff;
      box-shadow: 0px 0px 11rpx 0px rgba(63, 95, 150, 0.04);

      .title {
        width: 100%;
        margin: 36rpx 0 22px;
        text-align: center;
        font-size: 34rpx;
        font-weight: 500;
        color: #1f2329;
      }

      .update-data {
        padding: 12rpx 0;
        text-align: center;
      }

      .container {
        margin-top: 20rpx;

        .title {
          font-size: 16rpx;
          margin-top: 32rpx;
          font-weight: 800;
          text-align: left;
        }

        .time {
          text-align: left;
        }

        p {
          margin-bottom: 20rpx;

          .highlight {
            font-weight: 800;
          }

          a {
            color: #5a92f4;
          }

          &.compact {
            margin-bottom: 0px;
          }

          &.flex {
            display: flex;

            > span:nth-child(2) {
              margin-left: 1em;
            }
          }

          .q {
            margin-left: 1em;
          }
        }

        .update-data {
          .time {
            font-weight: 800;
          }

          p {
            font-weight: 800;
          }
        }
      }
    }
  }

  &.mobile {
    &.minip {
      .protocol {
        min-width: auto;
        max-width: none;
        margin: 0 auto;
        width: 100%;
        font-size: 3.4rem;

        .title {
          font-size: 3.4rem;
        }

        .update-data {
          font-size: 1.6rem;
        }

        .container {
          font-size: 1.9rem;

          .title {
            font-size: 2rem;
          }

          &.flex {
            display: flex;

            > span:nth-child(2) {
              margin-left: 1rem;
            }
          }

          .q {
            margin-left: 1rem;
          }
        }
      }
    }
  }
}
</style>
